<template>
  <v-flex style="overflow-x:auto">
  <table id="permissions-table">
    <thead>
      <tr>
        <th v-for="(resource, index) in resources" :key="index" class="text-truncate permission-label">
          <div>{{resource.name}}</div>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(team, teamIndex) in teams" :key="teamIndex">
        <slot v-for="(tasklist, resIndex) in tasklists">
          <td v-if="isReadPermission(getState(team,tasklist))" @click="toggleTasklistState(team, tasklist)" class="permission-check" :key="resIndex"> <v-icon class="letter" style="width:30px;" color="green">R</v-icon> </td>
          <td v-if="isWritePermission(getState(team,tasklist))" @click="toggleTasklistState(team, tasklist)" class="permission-check" :key="resIndex"> <v-icon class="letter" style="width:30px;" color="red">W</v-icon> </td>
          <td v-if="isNullPermission(getState(team,tasklist))" @click="toggleTasklistState(team, tasklist)" class="permission-check" :key="resIndex"> <v-icon class="letter" style="width:30px;">-</v-icon></td>
        </slot>
      </tr>
    </tbody>
  </table>
  </v-flex>
</template>

<script>
export const PermissionTypes = {
  READ: 'r',
  WRITE: 'w',
  NULL: ''
}
export default {
  name: "CaseConfigPermissionTasks",
  props: { caseType: { type: Object, required: true }, teams: { type: Array, required: true } },
  computed: {
    resources() {
      const resources = []
      const tasklistNames = this.tasklists.map(tl => tl.name)
      if (this.data && this.data.resources) {
        this.data.resources.forEach(function(resource) {
          if (resource.permissionType === "read_write_hidden" && resource.resourceType === "tasklist") {
            if (tasklistNames.includes(resource.name)) {
              resources.push(resource)
            }
          }
        })
      }
      return resources
    },
    tasklists() {
      const tasks = this.data.tasklists
      const tasklists = []
      if (this.data && this.data.resources) {
        this.data.resources.forEach(function(resource) {
          if (resource.permissionType === "read_write_hidden" && resource.resourceType === "tasklist") {
            if (tasks) {
              tasks.forEach(function(tasklist) {
                if (tasklist.name === resource.name) {
                  tasklists.push({ resourceId: resource.id, taskListId: tasklist.id, name: tasklist.name, permissionFlag: resource.permissionFlag })
                }
              })
            }
          }
        })
      }
      return tasklists
    },
    permissions() {
      const permissions = []
      if (this.data && this.data.resources) {
        this.data.resources.forEach(function(resource) {
          if (resource.permissionType === "read_write_hidden" && resource.resourceType === "tasklist") {
            const permission = this.data.permissions.find((permission) => (permission.resource.id === resource.id))
            if (permission) {
              permissions.push(permission)
            }
          }
        })
      }
      return permissions
    },
    data() {
      if (this.caseType) {
        return {
          caseTypeId: this.caseType.id,
          permissions: this.caseType.permissions,
          resources: this.caseType.resources,
          accessTeams: this.caseType.teams,
          tasklists: this.caseType.tasklistTemplates
        }
      }
      return undefined
    }
  },
  methods: {
    getState(team, tasklist) {
      const permission = this.data.permissions.find((currentPermission) => (currentPermission.team.id === team.id && currentPermission.resource.id === tasklist.resourceId))
      if (permission) {
        return permission.permissionFlag
      } else {
        return ""
      }
    },
    isReadPermission(permission) {
      return permission === PermissionTypes.READ
    },
    isWritePermission(permission) {
      return permission === PermissionTypes.WRITE
    },
    isNullPermission(permission) {
      return permission === PermissionTypes.NULL
    },
    async toggleTasklistState(team, tasklist) {
      const permission = this.data.permissions.find((currentPermission) => (currentPermission.team.id === team.id && currentPermission.resource.id === tasklist.resourceId))
      if (permission) {
        switch (permission.permissionFlag) {
          case "r":
            await this.deletePermission({ caseTypeId: this.data.caseTypeId, teamId: team.id, resourceId: tasklist.resourceId, tasklistId: tasklist.taskListId })
            await this.createPermission({ caseTypeId: this.data.caseTypeId, teamId: team.id, resourceId: tasklist.resourceId, tasklistId: tasklist.taskListId, tasklistName: tasklist.name, readOrWrite: "WRITE" })
            break
          case "w":
            await this.deletePermission({ caseTypeId: this.data.caseTypeId, teamId: team.id, resourceId: tasklist.resourceId, tasklistId: tasklist.taskListId })
            break
          default:
            await this.createPermission({ caseTypeId: this.data.caseTypeId, teamId: team.id, resourceId: tasklist.resourceId, tasklistId: tasklist.taskListId, tasklistName: tasklist.name, readOrWrite: "READ" })
        }
      } else {
        await this.createPermission({ caseTypeId: this.data.caseTypeId, teamId: team.id, resourceId: tasklist.resourceId, tasklistId: tasklist.taskListId, tasklistName: tasklist.name, readOrWrite: "READ" })
      }
    },
    async createPermission(permData) {
      const newPermission = await this.$store.dispatch("grantTasklistPermission", permData)
      if (newPermission && !newPermission.error) { this.data.permissions.push(newPermission) }
    },
    async deletePermission(permData) {
      const response = await this.$store.dispatch("revokeTasklistPermission", permData)
      if (response && !response.error) {
        const permission = this.data.permissions.find((currentPermission) => (currentPermission.team.id === permData.teamId && currentPermission.resource.id === permData.resourceId))
        const index = this.data.permissions.indexOf(permission)
        if (index >= 0) this.data.permissions.splice(index, 1)
      }
    }
  }
}
</script>
